"use client";

import React from "react";
import { Button } from "react-bootstrap";
import Link from "next/link";

interface ManagedServiceProps {
  serviceName: string;
  country: string; 
}

const ServerVideoSection: React.FC<ManagedServiceProps> = ({ serviceName, country }) => {
  const serviceContent: Record<
    string,
    {
      countries: Record<
        string,
        { title: string; subtitle: string; points: string[]; videoUrl: string }
      >;
    }
  > = {
    "Dedicated Server": {
      countries: {
        USA: {
          title: "Unleash Peak Performance with Our USA Dedicated Servers",
          subtitle: "Experience Unmatched Power, Speed, and Reliability",
          points: [
            "✓ Blazing Speed, 99.99% Uptime",
            "✓ Proactive 24/7 Support",
            "✓ Scalable Solutions for Your Success",
          ],
          videoUrl: "https://player.vimeo.com/video/889146148",
        },
        Netherlands: {
          title: "Supercharge Your Success with Netherlands Dedicated Servers",
          subtitle: "Harness Dutch Power for Peak Performance and Reliability",
          points: [
            "✓ Lightning-Fast Dutch Speed",
            "✓ Rock-Solid 99.99% Uptime",
            "✓ Local Expertise, Global Excellence",
          ],
          videoUrl: "https://player.vimeo.com/video/889146148",
        },
        Russia: {
          title: "Unleash Russian Potential with Our Dedicated Servers",
          subtitle: "Empower Your Online Presence with Robust Russian Hosting",
          points: [
            "✓ Blazing Russian Speed, Global Reach",
            "✓ Ironclad Security and Reliability",
            "✓ 24/7 Russian-Speaking Support for Your Success",
          ],
          videoUrl: "https://player.vimeo.com/video/889146148",
        },
        France: {
          title: "Elevate Your Online Presence with French Dedicated Servers",
          subtitle: "Unleash Speed, Security, and Scalability in the Heart of France",
          points: [
            "✓ Lightning-Fast French Connection, Global Impact",
            "✓ Fort Knox-Level Security for Your Data",
            "✓ Scalable Solutions Tailored to Your Success",
          ],
          videoUrl: "https://player.vimeo.com/video/889146148",
        },
        Canada: {
          title: "Supercharge Your Presence with Canadian Dedicated Servers",
          subtitle: "Unlock Speed, Security, and Support from Canada",
          points: [
            "✓ Blazing Canadian Speed",
            "✓ Ironclad Security",
            "✓ 24/7 Local Support",
          ],
          videoUrl: "https://player.vimeo.com/video/889146148",
        },
        Italy: {
          title: "Unleash Italian Excellence with Dedicated Servers",
          subtitle: "Where Speed, Security, and Support Meet",
          points: [
            "✓ Lightning-Fast Italian Performance",
            "✓ Ironclad Data Security",
            "✓ 24/7 Local Support",
          ],
          videoUrl: "https://player.vimeo.com/video/889146148",
        },
        Japan: {
          title: "Elevate Your Digital Future with Japanese Dedicated Servers",
          subtitle: "Unleash Cutting-Edge Performance in the Land of Innovation",
          points: [
            "✓ Lightning-Speed Connectivity in Japan Tech Hub",
            "✓ Ironclad Security for Your Peace of Mind",
            "✓ 24/7 Expert Support, Seamless Success",
          ],
          videoUrl: "https://player.vimeo.com/video/889146148",
        },
        Korea: {
          title: "Ignite Your Online Potential with Korean Dedicated Servers",
          subtitle: "Unlock Unmatched Speed and Reliability in the Heart of Korea",
          points: [
            "✓ Lightning-Fast Korean Connectivity for Rapid Performance",
            "✓ Ironclad Security to Safeguard Your Digital Assets",
            "✓ 24/7 Expert Support, Your Partner for Success",
          ],
          videoUrl: "https://player.vimeo.com/video/889146148",
        },
        Malaysia: {
          title: "Elevate Your Online Presence with Malaysian Dedicated Servers",
          subtitle: "Experience Speed, Security, and Support in the Heart of Malaysia",
          points: [
            "✓ Lightning-Fast Malaysian Connectivity for Peak Performance",
            "✓ Fortified Security to Protect Your Digital Assets",
            "✓ 24/7 Expert Support, Your Partner for Success",
          ],
          videoUrl: "https://player.vimeo.com/video/889146148",
        },
        Singapore: {
          title: "Turbocharge Your Success with Singapore Dedicated Servers",
          subtitle: "Unlock Unrivaled Speed, Security, and Support in Singapore",
          points: [
            "✓ Blazing-Fast Singaporean Connectivity for Lightning Performance",
            "✓ Ironclad Security to Safeguard Your Digital Assets",
            "✓ 24/7 Expert Support, Your Pathway to Success",
          ],
          videoUrl: "https://player.vimeo.com/video/889146148",
        },
        Germany: {
          title: "Empower Your Online Dominance with German Dedicated Servers",
          subtitle: "Unleash Speed, Security, and Reliability in the Heart of Europe",
          points: [
            "✓ Lightning-Fast German Connectivity for Unparalleled Performance",
            "✓ Fortified Security to Safeguard Your Digital Assets",
            "✓ 24/7 Expert Support, Your Catalyst for Success",
          ],
          videoUrl: "https://player.vimeo.com/video/889146148",
        },
        UAE: {
          title: "Elevate Your Online Presence with UAE Dedicated Servers",
          subtitle: "Experience the Power of Performance, Security, and Support in the UAE",
          points: [
            "✓ Lightning-Fast UAE Connectivity for Peak Online Performance",
            "✓ Fortified Security to Safeguard Your Digital Assets",
            "✓ 24/7 Expert Support, Your Partner for Online Success",
          ],
          videoUrl: "https://player.vimeo.com/video/889146148",
        },
        Turkey: {
          title: "Turbocharge Your Digital Presence with Turkish Dedicated Servers",
          subtitle: "Unleash Speed, Security, and Support from the Crossroads of Continents",
          points: [
            "✓ Lightning-Fast Turkish Connectivity for Exceptional Performance",
            "✓ Ironclad Security to Safeguard Your Digital Assets",
            "✓ 24/7 Expert Support, Your Path to Online Success",
          ],
          videoUrl: "https://player.vimeo.com/video/889146148",
        },
        UK: {
          title: "Elevate Your Online Excellence with UK Dedicated Servers",
          subtitle: "Unleash Speed, Security, and Support in the Heart of the UK",
          points: [
            "✓ Lightning-Fast UK Connectivity for Peak Performance",
            "✓ Fortified Security to Safeguard Your Digital Assets",
            "✓ 24/7 Expert Support, Your Partner for Online Success",
          ],
          videoUrl: "https://player.vimeo.com/video/889146148",
        },
        Bulgaria: {
          title: "Unleash Your Digital Potential with Bulgarian Dedicated Servers",
          subtitle: "Experience Speed, Security, and Support in the Heart of Bulgaria",
          points: [
            "✓ Lightning-Fast Bulgarian Connectivity for Peak Online Performance",
            "✓ Ironclad Security to Safeguard Your Digital Assets",
            "✓ 24/7 Expert Support, Your Gateway to Online Success",
          ],
          videoUrl: "https://player.vimeo.com/video/889146148",
        },
        SaudiArabia: {
          title: "Empower Your Digital Dominance with Saudi Arabian Dedicated Servers",
          subtitle: "Unlock Unmatched Speed, Security, and Support in Saudi Arabia",
          points: [
            "✓ Lightning-Fast Saudi Connectivity for Peak Online Performance",
            "✓ Fortified Security to Safeguard Your Digital Assets",
            "✓ 24/7 Expert Support, Your Partner for Online Success",
          ],
          videoUrl: "https://player.vimeo.com/video/889146148",
        },
        Thailand: {
          title: "Thailand is Gateway to Digital Excellence: Dedicated Servers at Their Best",
          subtitle: "Experience Unrivaled Speed, Security, and Support in Thailand",
          points: [
            "✓ Lightning-Fast Thai Connectivity for Top Online Performance",
            "✓ Ironclad Security to Protect Your Digital Assets",
            "✓ 24/7 Expert Support, Your Partner for Online Success",
          ],
          videoUrl: "https://player.vimeo.com/video/889146148",
        },
        China: {
          title: "Unleash Digital Prowess with Chinese Dedicated Servers",
          subtitle: "Harness Speed, Security, and Support in the Heart of China",
          points: [
            "✓ Lightning-Fast Chinese Connectivity for Peak Online Performance",
            "✓ Fortified Security to Safeguard Your Digital Assets",
            "✓ 24/7 Expert Support, Your Path to Online Success",
          ],
          videoUrl: "https://player.vimeo.com/video/889146148",
        },

        SouthAmerica: {
          title: "Empower Your Digital Presence with South American Dedicated Servers",
    subtitle: "Unlock Speed, Security, and Support in the Heart of South America",
    points: [
      "Lightning-Fast South American Connectivity for Optimal Performance",
      "Fortified Security to Safeguard Your Digital Assets",
      "24/7 Expert Support, Your Partner for Online Success in South America",
    ],
          videoUrl: "https://player.vimeo.com/video/889146148",
        },

        HongKong: {
          title: "Elevate Your Digital Power with Hong Kong Dedicated Servers",
          subtitle: "Experience Speed, Security, and Support in the Heart of Asia",
          points: [
            "Blazing-Fast Hong Kong Connectivity for Peak Online Performance",
            "Robust Security to Safeguard Your Digital Assets",
            "24/7 Expert Support, Your Path to Online Success in Asia",
          ],
          videoUrl: "https://player.vimeo.com/video/889146148",
        },
      },
    },
    "Dedicated Special Deals": {
      countries: {
      USA: {
        title: "Bare Metal Dedicated Servers",
      subtitle: "The configuration you need, ready when you are.",
      points: [
        "✓ No long term contracts, pay for only what you use",
        "✓ Spin up Bare Metal Cloud servers and networks programmatically",
        "✓ Bootstrap any application in seconds with cloud-init and post install scripts",
      ],
        videoUrl: "https://player.vimeo.com/video/889146148",
      },
    },
 
    },
    "Windows Remote Desktop": {
      countries: {
        USA: {
          title: "Unlock Seamless Remote Access with Temok Cutting-Edge RDP Servers in the USA!",
          subtitle: "Empower Your Workforce Anywhere, Anytime with High-performance RDP Solutions Tailored to the USA.",
          points: [
            "✓ Experience lightning-fast speeds and low latency for a responsive remote desktop experience.",
            "✓ Our USA-based RDP servers feature advanced security measures for protecting your sensitive data.",
            "✓ Trust in our round-the-clock support and server reliability for uninterrupted productivity.",
          ],
          videoUrl: "https://player.vimeo.com/video/889146148",
        },
        Canada: {
          title: "Elevate Your Remote Experience with Temok High-Powered RDP Servers in Canada!",
          subtitle: "Seamless Connectivity, Unmatched Performance – Your Ideal RDP Solution Anchored in Canada.",
          points: [
            "✓ Immerse yourself in smooth virtual desktop interactions with our lightning-fast Canadian RDP servers.",
            "✓ Benefit from enhanced security protocols, ensuring your data stays protected on Canadian soil.",
            "✓ Unlock a 24/7 support lifeline, ensuring your Canadian RDP experience is always optimized and hassle-free.",
          ],
          videoUrl: "https://player.vimeo.com/video/889146148",
        },
        Ireland: {
          title: "Empower Your Remote Operations with Temok Cutting-Edge RDP Servers in Ireland!",
          subtitle: "Seamless Connectivity, Maximum Efficiency: Elevate Your Remote Work Experience.",
          points: [
            "✓ Unlock unparalleled speed with our Ireland-based RDP servers, optimizing your operations.",
            "✓ Safeguard your data with top-notch security protocols and data encryption.",
            "✓ Experience the convenience of centralized access, tailored for Irish businesses and beyond.",
          ],
          videoUrl: "https://player.vimeo.com/video/889146148",
        },
        UK: {
          title: "Powerful Connectivity, Exceptional Control: Temok UK RDP Servers Redefine Remote Operations!",
          subtitle: "Transform Your Remote Work Experience with High-Performance RDP Servers in the UK.",
          points: [
            "✓ Unleash productivity with lightning-fast RDP connections tailored for UK-based operations.",
            "✓ Secure your data and operations with robust encryption and advanced security measures.",
            "✓ Elevate user experience by leveraging strategically positioned servers for optimal accessibility.",
          ],
          videoUrl: "https://player.vimeo.com/video/889146148",
        },
        France: {
          title: "Unlock Seamless Connectivity: Temok RDP Servers in France Redefine Remote Access!",
          subtitle: "Experience Peak Performance and Security with Our Cutting-edge RDP Solutions.",
          points: [
            "✓ Elevate your workflow with high-speed, low-latency RDP connections from France.",
            "✓ Fortify your digital workspace with advanced security protocols and encryption.",
            "✓ Optimize your user experience with servers strategically located for reliability and efficiency.",
          ],
          videoUrl: "https://player.vimeo.com/video/889146148",
        },
        Germany: {
          title: "Unleash German Precision: Elevate Your Digital Experience with Temok RDP Servers!",
          subtitle: "Experience Unrivaled Performance and Security for Your Remote Desktop Needs.",
          points: [
            "✓ Navigate with confidence using lightning-fast RDP connections in Germany.",
            "✓ Elevate your digital defense with state-of-the-art security features and encryption.",
            "✓ Leverage the power of German infrastructure for reliability and optimal server performance.",
          ],
          videoUrl: "https://player.vimeo.com/video/889146148",
        },
        Singapore: {
          title: "Skyrocket Your Digital Ascendancy with Temok RDP Servers in Singapore!",
          subtitle: "Unleash Peak Performance - Elevate Your Virtual Experience in the Heart of Asia.",
          points: [
            "✓ Lightning-fast RDP servers strategically stationed in Singapore.",
            "✓ Fortify your data fortress with cutting-edge security.",
            "✓ 24/7 customer support for an uninterrupted digital journey.",
          ],
          videoUrl: "https://player.vimeo.com/video/889146148",
        },
        Australia: {
          title: "Elevate Your Digital Experience with Temok Australian RDP Servers!",
          subtitle: "Seamless Connectivity, Robust Performance - Unleash the Power of Down Under.",
          points: [
            "✓ Experience blazing-fast RDP connections with our servers in Australia.",
            "✓ Ensure data sovereignty and compliance with top-notch security protocols.",
            "✓ 24/7 customer support, because your success knows no time zone.",
          ],
          videoUrl: "https://player.vimeo.com/video/889146148",
        },
        Japan: {
          title: "Unlock Digital Possibilities with Temok Japanese RDP Servers!",
          subtitle: "Elevate Your Online Experience with Lightning-Fast Connections in Japan.",
          points: [
            "✓ Seamlessly connect to your RDP server with unparalleled speed and efficiency.",
            "✓ Ensure data residency and compliance with Japan's stringent security standards.",
            "✓ Experience 24/7 dedicated support because your success is our priority.",
          ],
          videoUrl: "https://player.vimeo.com/video/889146148",
        },
        Korea: {
          title: "Empower Your Digital Journey with Temok Korean RDP Servers!",
          subtitle: "Experience Unrivaled Connectivity and Performance in Korea.",
          points: [
            "✓ Elevate productivity with lightning-fast, low-latency connections for your RDP server.",
            "✓ Secure your data with cutting-edge technology, meeting Korea's rigorous standards.",
            "✓ Our expert support team is at your service 24/7, ensuring a seamless experience.",
          ],
          videoUrl: "https://player.vimeo.com/video/889146148",
        },
        India: {
          title: "Unlock Seamless Digital Access with Temok Indian RDP Servers!",
          subtitle: "Elevate Your Online Experience with High-Performance RDP Servers in India.",
          points: [
            "✓ Experience lightning-fast connectivity for smooth remote desktop operations.",
            "✓ Secure your critical data with our state-of-the-art security measures.",
            "✓ Our dedicated support team is available 24/7 to ensure your success and satisfaction.",
          ],
          videoUrl: "https://player.vimeo.com/video/889146148",
        },
        SaudiArabia: {
          title: "Empower Your Digital Presence with Temok RDP Servers in Saudi Arabia!",
          subtitle: "Seamless Remote Access for Your Success: Discover the Power of Saudi RDP Servers.",
          points: [
            "✓ Elevate your workflow with high-speed connections tailored for optimal performance.",
            "✓ Fortify your data integrity with cutting-edge security protocols.",
            "✓ Count on our 24/7 support to ensure uninterrupted accessibility and peace of mind.",
          ],
          videoUrl: "https://player.vimeo.com/video/889146148",
        },
        UAE: {
          title: "Unlock Exceptional Remote Performance with Temok RDP Servers in UAE!",
          subtitle: "Fast, Secure, and Tailored for Success: Experience Superior RDP Solutions in the UAE.",
          points: [
            "✓ Elevate your productivity with lightning-fast connections for seamless remote operations.",
            "✓ Safeguard your data with advanced security measures, ensuring confidentiality.",
            "✓ Our 24/7 support guarantees a smooth experience, addressing your needs instantly.",
          ],
          videoUrl: "https://player.vimeo.com/video/889146148",
        },
        Malaysia: {
          title: "Experience Top-Tier RDP Solutions in Malaysia – Empowering Your Connectivity!",
          subtitle: "Maximize Efficiency and Security with Temok Unmatched RDP Servers in Malaysia.",
          points: [
            "✓ Turbocharge your workflow with rapid, uninterrupted connections for ultimate productivity.",
            "✓ Fortify your data with cutting-edge security protocols, ensuring confidentiality.",
            "✓ Our 24/7 expert support ensures a seamless experience, addressing your needs promptly.",
          ],
          videoUrl: "https://player.vimeo.com/video/889146148",
        },
        Indonesia: {
          title: "Elevate Your Digital Experience with Temok RDP Servers in Indonesia!",
          subtitle: "Unlock Unprecedented Connectivity and Security with Our Premium RDP Solutions.",
          points: [
            "✓ Seamless collaboration and swift data access for heightened productivity.",
            "✓ Bank-grade encryption ensures your data safety in the digital realm.",
            "✓ Experience unparalleled reliability with our 99.9% uptime guarantee.",
          ],
          videoUrl: "https://player.vimeo.com/video/889146148",
        },
        Italy: {
          title: "Empower Your Digital Ventures with Temok Elite RDP Servers in Italy!",
          subtitle: "Transform Your Online Presence with Unmatched Performance and Security.",
          points: [
            "✓ Supercharge your workflow with high-speed, low-latency RDP connections.",
            "✓ Fortify your digital assets with advanced security protocols and encryption.",
            "✓ Italian data centers ensure optimal performance for your business needs.",
          ],
          videoUrl: "https://player.vimeo.com/video/889146148",
        },
      },
    },
    "Windows VPS": {
      countries: {
        USA: {
          title: "Supercharge Your Digital Ascent with Windows VPS from the USA",
          subtitle: "Experience High-Speed, Security, and Support in the Heart of Innovation",
          points: [
            "✓ Lightning-Fast US Connectivity for Optimal Windows VPS Performance",
            "✓ Ironclad Security to Safeguard Your Digital Ventures",
            "✓ 24/7 Expert Support, Your Gateway to Seamless VPS Success in the USA.",
          ],
          videoUrl: "https://player.vimeo.com/video/889146148",
        },
        Canada: {
          title: "Elevate Your Digital Potential with Windows VPS from Canada",
          subtitle: "Experience High-Speed, Security, and Support in the Heart of North America",
          points: [
            "✓ Lightning-Fast Canadian Connectivity for Optimal Windows VPS Performance",
            "✓ Robust Security to Safeguard Your Digital Ventures",
            "✓ 24/7 Expert Support, Your Gateway to Seamless VPS Success in Canada.",
          ],
          videoUrl: "https://player.vimeo.com/video/889146148",
        },
        Ireland: {
          title: "Elevate Your Digital Future with Windows VPS from Ireland",
          subtitle: "Experience High-Speed, Security, and Support in the Heart of Europe",
          points: [
            "✓ Lightning-Fast Irish Connectivity for Optimal Windows VPS Performance",
            "✓ Ironclad Security to Safeguard Your Digital Ventures",
            "✓ 24/7 Expert Support, Your Gateway to Seamless VPS Success in Ireland.",
          ],
          videoUrl: "https://player.vimeo.com/video/889146148",
        },
        UK: {
          title: "Empower Your Digital Ambitions with Windows VPS from the UK",
          subtitle: "Experience High-Speed, Security, and Support in the Heart of Innovation",
          points: [
            "✓ Lightning-Fast UK Connectivity for Optimal Windows VPS Performance",
            "✓ Robust Security to Safeguard Your Digital Ventures",
            "✓ 24/7 Expert Support, Your Gateway to Seamless VPS Success in the UK.",
          ],
          videoUrl: "https://player.vimeo.com/video/889146148",
        },
        France: {
          title: "Elevate Your Digital Odyssey with Windows VPS from France",
          subtitle: "Experience High-Speed, Security, and Support in the Heart of Europe",
          points: [
            "✓ Lightning-Fast French Connectivity for Optimal Windows VPS Performance",
            "✓ Ironclad Security to Safeguard Your Digital Ventures",
            "✓ 24/7 Expert Support, Your Gateway to Seamless VPS Success in France.",
          ],
          videoUrl: "https://player.vimeo.com/video/889146148",
        },
        Germany: {
          title: "Elevate Your Digital Journey with Windows VPS from Germany",
          subtitle: "Experience High-Speed, Security, and Support in the Heart of Europe",
          points: [
            "✓ Lightning-Fast German Connectivity for Optimal Windows VPS Performance",
            "✓ Robust Security to Safeguard Your Digital Ventures",
            "✓ 24/7 Expert Support, Your Gateway to Seamless VPS Success in Germany.",
          ],
          videoUrl: "https://player.vimeo.com/video/889146148",
        },
        Singapore: {
          title: "Supercharge Your Digital Future with Windows VPS from Singapore",
          subtitle: "Experience High-Speed, Security, and Support in the Heart of Asia",
          points: [
            "✓ Lightning-Fast Singaporean Connectivity for Optimal Windows VPS Performance",
            "✓ Ironclad Security to Safeguard Your Digital Ventures",
            "✓ 24/7 Expert Support, Your Gateway to Seamless VPS Success in Asia.",
          ],
          videoUrl: "https://player.vimeo.com/video/889146148",
        },
        Australia: {
          title: "Elevate Your Digital Ascent with Windows VPS from Australia",
          subtitle: "Experience High-Speed, Security, and Support Down Under",
          points: [
            "✓ Lightning-Fast Australian Connectivity for Optimal Windows VPS Performance",
            "✓ Robust Security to Safeguard Your Digital Ventures",
            "✓ 24/7 Expert Support, Your Gateway to Seamless VPS Success in Australia.",
          ],
          videoUrl: "https://player.vimeo.com/video/889146148",
        },
        Japan: {
          title: "Elevate Your Digital Odyssey with Windows VPS from Japan",
          subtitle: "Experience High-Speed, Security, and Support in the Land of Innovation",
          points: [
            "✓ Lightning-Fast Japanese Connectivity for Optimal Windows VPS Performance",
            "✓ Ironclad Security to Safeguard Your Digital Ventures",
            "✓ 24/7 Expert Support, Your Gateway to Seamless VPS Success in Japan.",
          ],
          videoUrl: "https://player.vimeo.com/video/889146148",
        },
        Korea: {
          title: "Empower Your Digital Future with Windows VPS from Korea",
          subtitle: "Experience High-Speed, Security, and Support in the Heart of Innovation",
          points: [
            "✓ Lightning-Fast Korean Connectivity for Optimal Windows VPS Performance",
            "✓ Robust Security to Safeguard Your Digital Ventures",
            "✓ 24/7 Expert Support, Your Gateway to Seamless VPS Success in Korea.",
          ],
          videoUrl: "https://player.vimeo.com/video/889146148",
        },
        India: {
          title: "Elevate Your Digital Horizon with Windows VPS from India",
          subtitle: "Experience High-Speed, Security, and Support in the Land of Innovation",
          points: [
            "✓ Lightning-Fast Indian Connectivity for Optimal Windows VPS Performance",
            "✓ Ironclad Security to Safeguard Your Digital Ventures",
            "✓ 24/7 Expert Support, Your Gateway to Seamless VPS Success in India.",
          ],
          videoUrl: "https://player.vimeo.com/video/889146148",
        },
        SaudiArabia: {
          title: "Empower Your Digital Excellence with Windows VPS from Saudi Arabia",
          subtitle: "Experience High-Speed, Security, and Support in the Heart of the Middle East",
          points: [
            "✓ Lightning-Fast Saudi Connectivity for Optimal Windows VPS Performance",
            "✓ Robust Security to Safeguard Your Digital Ventures",
            "✓ 24/7 Expert Support, Your Gateway to Seamless VPS Success in Saudi Arabia.",
          ],
          videoUrl: "https://player.vimeo.com/video/889146148",
        },
        UAE: {
          title: "Elevate Your Digital Journey with Windows VPS from the UAE",
          subtitle: "Experience High-Speed, Security, and Support in the Heart of Innovation",
          points: [
            "✓ Lightning-Fast UAE Connectivity for Optimal Windows VPS Performance",
            "✓ Ironclad Security to Safeguard Your Digital Ventures",
            "✓ 24/7 Expert Support, Your Gateway to Seamless VPS Success in the UAE.",
          ],
          videoUrl: "https://player.vimeo.com/video/889146148",
        },
        Malaysia: {
          title: "Elevate Your Digital Presence with Windows VPS from Malaysia",
          subtitle: "Experience High-Speed, Security, and Support in the Heart of Southeast Asia",
          points: [
            "✓ Lightning-Fast Malaysian Connectivity for Optimal Windows VPS Performance",
            "✓ Robust Security to Safeguard Your Digital Ventures",
            "✓ 24/7 Expert Support, Your Gateway to Seamless VPS Success in Malaysia.",
          ],
          videoUrl: "https://player.vimeo.com/video/889146148",
        },
        Indonesia: {
          title: "Elevate Your Digital Aspirations with Windows VPS from Indonesia",
          subtitle: "Experience High-Speed, Security, and Support in the Heart of Southeast Asia",
          points: [
            "✓ Lightning-Fast Indonesian Connectivity for Optimal Windows VPS Performance",
            "✓ Ironclad Security to Safeguard Your Digital Ventures",
            "✓ 24/7 Expert Support, Your Gateway to Seamless VPS Success in Indonesia.",
          ],
          videoUrl: "https://player.vimeo.com/video/889146148",
        },
        Italy: {
          title: "Elevate Your Digital Journey with Windows VPS from Italy",
          subtitle: "Experience High-Speed, Security, and Support in the Heart of Europe",
          points: [
            "✓ Lightning-Fast Italian Connectivity for Optimal Windows VPS Performance",
            "✓ Robust Security to Safeguard Your Digital Ventures",
            "✓ 24/7 Expert Support, Your Gateway to Seamless VPS Success in Italy.",
          ],
          videoUrl: "https://player.vimeo.com/video/889146148",
        },
      },
    },
    "Linux VPS": {
      countries: {
        USA: {
          title: "Unleash Your Potential with Linux VPS from New York, USA",
          subtitle: "Experience Blazing Speed, Reliability, and Support at the Heart of the Big Apple",
          points: [
            "✓ Lightning-Fast New York Connectivity for Optimal VPS Performance",
            "✓ Rock-Solid Reliability to Safeguard Your Digital Projects",
            "✓ 24/7 Expert Support, Your Partner for Seamless VPS Success in the USA.",  
          ],
          videoUrl: "https://player.vimeo.com/video/889146148",
        },
         SAN: {
          title: "Supercharge Your Digital Journey with Linux VPS from San Francisco, USA",
          subtitle: "Experience Peak Performance, Security, and Support in the Heart of Tech Innovation",
          points: [  
            "✓ High-Speed San Francisco Connectivity for Maximum VPS Performance",
            "✓ Ironclad Security to Safeguard Your Digital Ventures",
            "✓ 24/7 Expert Support, Your Gateway to Seamless VPS Success in the USA."

          ],
          videoUrl: "https://player.vimeo.com/video/889146148",
        }, 
        Netherlands: {
          title: "Elevate Your Digital Game with Linux VPS from the Netherlands",
          subtitle: "Unleash Speed, Security, and Support at the Heart of Europe",
          points: [
            "✓ Lightning-Fast Dutch Connectivity for Peak VPS Performance",
            "✓ Fortified Security to Safeguard Your Digital Ventures",
            "✓ 24/7 Expert Support, Your Pathway to Seamless VPS Success in Europe.",
          ],
          videoUrl: "https://player.vimeo.com/video/889146148",
        },
        Singapore: {
          title: "Elevate Your Digital Presence with Linux VPS from Singapore",
          subtitle: "Experience Blazing Speed, Security, and Support in the Heart of Asia",
          points: [
            "✓ Lightning-Fast Singaporean Connectivity for Optimal VPS Performance",
            "✓ Ironclad Security to Safeguard Your Digital Ventures",
            "✓ 24/7 Expert Support, Your Pathway to Seamless VPS Success in Asia."
          ],
          videoUrl: "https://player.vimeo.com/video/889146148",
        },
        
        Germany: {
          title: "Empower Your Digital Journey with Linux VPS from Germany",
          subtitle: "Unlock Speed, Security, and Support at the Heart of Europe",
          points: [
            "✓ Lightning-Fast German Connectivity for Peak VPS Performance",
            "✓ Fortified Security to Safeguard Your Digital Ventures",
            "✓ 24/7 Expert Support, Your Gateway to Seamless VPS Success in Europe."
          ],
          videoUrl: "https://player.vimeo.com/video/889146148",
        },
        
        UK: {
          title: "Elevate Your Digital Potential with Linux VPS from the UK",
          subtitle: "Experience High-Speed, Security, and Support in the Heart of Britain",
          points: [
            "✓ Lightning-Fast UK Connectivity for Peak VPS Performance",
            "✓ Ironclad Security to Safeguard Your Digital Ventures",
            "✓ 24/7 Expert Support, Your Gateway to Seamless VPS Success in the UK."
          ],
          videoUrl: "https://player.vimeo.com/video/889146148",
        },
        
        Canada: {
          title: "Unleash Your Digital Potential with Linux VPS from Canada",
          subtitle: "Experience Speed, Security, and Support in the Great White North",
          points: [
            "✓ Lightning-Fast Canadian Connectivity for Peak VPS Performance",
            "✓ Fortified Security to Safeguard Your Digital Ventures",
            "✓ 24/7 Expert Support, Your Gateway to Seamless VPS Success in Canada."
          ],
          videoUrl: "https://player.vimeo.com/video/889146148",
        },
        
        India: {
          title: "Supercharge Your Digital Journey with Linux VPS from India",
          subtitle: "Experience High-Speed, Security, and Support in the Heart of India",
          points: [
            "✓ Lightning-Fast Indian Connectivity for Peak VPS Performance",
            "✓ Ironclad Security to Safeguard Your Digital Ventures",
            "✓ 24/7 Expert Support, Your Gateway to Seamless VPS Success in India."
          ],
          videoUrl: "https://player.vimeo.com/video/889146148",
        },
        
        SaudiArabia: {
          title: "Elevate Your Digital Ascent with Linux VPS from Saudi Arabia",
          subtitle: "Experience High-Speed, Security, and Support in the Heart of the Middle East",
          points: [
            "✓ Lightning-Fast Saudi Connectivity for Peak VPS Performance",
            "✓ Fortified Security to Safeguard Your Digital Ventures",
            "✓ 24/7 Expert Support, Your Gateway to Seamless VPS Success in Saudi Arabia."
          ],
          videoUrl: "https://player.vimeo.com/video/889146148",
        },
        
        UAE: {
          title: "Amplify Your Digital Reach with Linux VPS from the UAE",
          subtitle: "Experience High-Speed, Security, and Support in the Heart of Innovation",
          points: [
            "✓ Lightning-Fast UAE Connectivity for Peak VPS Performance",
            "✓ Ironclad Security to Safeguard Your Digital Ventures",
            "✓ 24/7 Expert Support, Your Gateway to Seamless VPS Success in the UAE."
          ],
          videoUrl: "https://player.vimeo.com/video/889146148",
        },
        
        Italy: {
          title: "Elevate Your Digital Horizon with Linux VPS from Italy",
          subtitle: "Experience High-Speed, Security, and Support in the Heart of Europe",
          points: [
            "✓ Lightning-Fast Italian Connectivity for Peak VPS Performance",
            "✓ Fortified Security to Safeguard Your Digital Ventures",
            "✓ 24/7 Expert Support, Your Gateway to Seamless VPS Success in Italy."
          ],
          videoUrl: "https://player.vimeo.com/video/889146148",
        },
        
        Malaysia: {
          title: "Elevate Your Digital Aspirations with Linux VPS from Malaysia",
          subtitle: "Experience High-Speed, Security, and Support in the Heart of Southeast Asia",
          points: [
            "✓ Lightning-Fast Malaysian Connectivity for Peak VPS Performance",
            "✓ Ironclad Security to Safeguard Your Digital Ventures",
            "✓ 24/7 Expert Support, Your Gateway to Seamless VPS Success in Malaysia."
          ],
          videoUrl: "https://player.vimeo.com/video/889146148",
        },

        Indonesia: {
          title: "Empower Your Digital Journey with Linux VPS from Indonesia",
          subtitle: "Experience High-Speed, Security, and Support in the Heart of Southeast Asia",
          points: [
            "✓ Lightning-Fast Indonesian Connectivity for Peak VPS Performance",
            "✓ Fortified Security to Safeguard Your Digital Ventures",
            "✓ 24/7 Expert Support, Your Gateway to Seamless VPS Success in Indonesia."
          ],
          videoUrl: "https://player.vimeo.com/video/889146148",
        },
      },
    }, 
    "Mac Mini M2": {
      countries: {
        USA: {
          title: "Your Vision, Our Mac Mini M2!",
          subtitle: "Temok Mac mini M2 is a versatile and economical choice for an Apple environment.",
          points: [],
          videoUrl: "https://player.vimeo.com/video/889146148",
        },
      },
       
},
  };
 
  // Get service data
  const service = serviceContent[serviceName];

  // Get content for the selected country, defaulting to "USA" if not found
  const content = service?.countries[country] || service?.countries["USA"];
const link = process.env.NEXT_PUBLIC_API_BASE_URL+ "/register.php";
  return (
    <div className="custMargin">
    <div className="navBg py-5">
      <div className="container my-5">
        <div className="row align-items-center">
          <div className="col-lg-6 col-md-12 col-12">
            <div className="slogans">
              <h3 className="textOrange fw-bold display-6 fs-2">{content?.title}</h3>
              <h4 className="text-white fw-semibold fs-4">{content?.subtitle}</h4>
              <ul className="list-unstyled">
                {content?.points.map((point, index) => (
                  <li className="text-white py-2" key={index}>{point}</li>
                ))}
              </ul>
              <form className="d-flex mt-4 custAlign">
                <Button variant="primary" size="lg" className="mx-2 button">
                    <Link href={link} className="regButton" ><span>Create Account</span></Link>
                  </Button>
              </form>
            </div>
          </div>
          <div className="col-lg-6 col-md-12 col-12">
            <div>
              <iframe
                width="100%"
                height="400"
                src={`${content?.videoUrl}?badge=0&amp;autopause=0&amp;quality_selector=1&amp;player_id=0&amp;app_id=58479`}
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                title={content?.title}
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);
};

export default ServerVideoSection;